/** Display helpers. Everything here is presentation only - no game rules. */

export function formatNumber(value: number): string {
  return Math.floor(value).toLocaleString('en-GB');
}

/** 12,400 -> "12.4k". Used where column width matters. */
export function formatCompact(value: number): string {
  const n = Math.floor(value);
  if (Math.abs(n) < 1000) return String(n);
  if (Math.abs(n) < 1_000_000) return `${(n / 1000).toFixed(n < 10_000 ? 1 : 0)}k`;
  return `${(n / 1_000_000).toFixed(1)}m`;
}

/** Seconds -> "1d 04:12:09" / "04:12" for short spans. */
export function formatDuration(totalSeconds: number): string {
  const s = Math.max(0, Math.floor(totalSeconds));
  const days = Math.floor(s / 86_400);
  const hours = Math.floor((s % 86_400) / 3600);
  const minutes = Math.floor((s % 3600) / 60);
  const seconds = s % 60;

  const pad = (n: number) => String(n).padStart(2, '0');
  if (days > 0) return `${days}d ${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  if (hours > 0) return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  return `${pad(minutes)}:${pad(seconds)}`;
}

export function formatRate(perHour: number): string {
  const sign = perHour > 0 ? '+' : '';
  return `${sign}${formatNumber(perHour)}/h`;
}

export function formatCoords(x: number, y: number): string {
  return `(${x}|${y})`;
}

/** Seconds until a timestamp, floored at zero. */
export function secondsUntil(timestamp: number, now: number): number {
  return Math.max(0, Math.floor((timestamp - now) / 1000));
}

/** Turn a snake_case game key into a readable label. */
export function titleise(value: string): string {
  return value
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}
